import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { EventReducedFragmentDoc } from '../fragments/eventReducedFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetEventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', external_zoho_id?: string | null, carrier_pickup_date?: string | null, pickup_date_after_event?: string | null, default_logistics: Types.EventDefaultLogistics, merchant_order_form_deadline?: string | null, merchant_order_form_info_text?: string | null, minimum_cleaning_fee_rate?: number | null, id: string, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, is_authorized_signer_necessary: boolean, currency: string, entity: Types.LegalEntity, type: Types.EventType, is_deleted: boolean, main_contracting_event_account?: { __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null } | null, prices: Array<{ __typename?: 'EventPrice', kind: Types.EventPriceKind, container_type_id?: number | null, item_type_id?: number | null, rental_price?: number | null, cleaning_price?: number | null, deposit_price?: number | null, lost_price?: number | null, logistic_partner_cleaning_price?: number | null, is_default: boolean }>, event_participants?: Array<{ __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null, email?: string | null, is_billable: boolean, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event_id?: string | null, delivery_address?: { __typename?: 'IdName', id: string, name: string } | null }> | null, authorized_signers: Array<{ __typename?: 'AuthorizedSigner', id: string, name: string, event_account_id: string, event_account_name: string, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event_id?: string | null }> | null }> }> | null, allowed_container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image?: string | null, packing_unit?: number | null, segment?: Types.ContainerTypeSegment | null, color_hex_code?: string | null }>, allowed_item_types: Array<{ __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory, archived: boolean }> } | null };


export const GetEventDocument = gql`
    query getEvent($id: ID!) {
  event(id: $id) {
    ...EventReduced
    external_zoho_id
    carrier_pickup_date
    pickup_date_after_event
    default_logistics
    merchant_order_form_deadline
    merchant_order_form_info_text
    minimum_cleaning_fee_rate
    main_contracting_event_account {
      id
      name
      description
    }
    prices {
      kind
      container_type_id
      item_type_id
      rental_price
      cleaning_price
      deposit_price
      lost_price
      logistic_partner_cleaning_price
      is_default
    }
    event_participants {
      id
      name
      description
      email
      is_billable
      item_locations {
        id
        name
        event_id
        delivery_address {
          id
          name
        }
      }
      authorized_signers {
        id
        name
        event_account_id
        event_account_name
        allowed_item_locations {
          id
          name
          event_id
        }
      }
    }
  }
}
    ${EventReducedFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;